/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Chat unread.
 * @export
 */
export const ICON_CHAT_UNREAD = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 7.70703C20.6569 7.70703 22 6.36389 22 4.70703C22 3.05018 20.6569 1.70703 19 1.70703C17.3431 1.70703 16 3.05018 16 4.70703C16 6.36389 17.3431 7.70703 19 7.70703Z" />
    <path d="M7 9.70703C6.45 9.70703 6 9.25703 6 8.70703C6 8.15703 6.45 7.70703 7 7.70703H15.03C13.82 6.10703 13.95 4.49703 14.11 3.70703H4.01C2.91 3.70703 2.01 4.59703 2.01 5.70703L2 21.287C2 22.177 3.08 22.627 3.71 21.997L6 19.707H20C21.1 19.707 22 18.807 22 17.707V8.67703C21.16 9.31703 20.13 9.70703 19 9.70703H7ZM13 15.707H7C6.45 15.707 6 15.257 6 14.707C6 14.157 6.45 13.707 7 13.707H13C13.55 13.707 14 14.157 14 14.707C14 15.257 13.55 15.707 13 15.707ZM17 12.707H7C6.45 12.707 6 12.257 6 11.707C6 11.157 6.45 10.707 7 10.707H17C17.55 10.707 18 11.157 18 11.707C18 12.257 17.55 12.707 17 12.707Z" />
  </svg>
);
